export const BULLET_POINTS_COUNT = 3;

export const bulletPointPlaceholders = [
  'e.g. the math that makes scale work',
  'e.g. the hire that doubles your ceiling',
  'e.g. a business that runs without you',
];

export const toBulletPointFields = (bulletPoints?: string[]) =>
  Array.from({ length: BULLET_POINTS_COUNT }, (_, index) => bulletPoints?.[index] || '');
